var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import * as SearchParams from "search-params";
var params = SearchParams.parse(window.location.search.replace(/^\?/, ""));
var shouldPrint = !!params.find(function (param) { return param.name === "show_logs"; });
export default function createLog(moduleName) {
    return function () {
        var content = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            content[_i] = arguments[_i];
        }
        if (!shouldPrint)
            return;
        console.log.apply(console, __spreadArrays(["[ " + Date() + " ]", "[ " + moduleName + " ]"], content));
    };
}



//////////////////
// WEBPACK FOOTER
// ./src/log.ts
// module id = 18
// module chunks = 1